import { Link } from "react-router-dom";

interface ArticleCard {
  slug: string;
  title: string;
  category: string;
  description: string;
  imageUrl: string;
  isFeatured?: boolean;
}

const articleCards: ArticleCard[] = [
  {
    slug: "pandabuy-sheet-complete-guide",
    title: "Pandabuy Sheet: The Ultimate Shopping Guide for 2026",
    category: "Featured Guide",
    description: "Everything you need to know about using pandabuyspreadsheet to find trending fashion items, compare quality, and save hours of manual searching.",
    imageUrl: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20desk%20space%20with%20laptop%20displaying%20organized%20spreadsheet%20data%20alongside%20fashion%20magazines%20and%20coffee%20on%20warm%20oak%20desk%2C%20soft%20natural%20window%20light%2C%20Scandinavian%20workspace%20vibe%2C%20editorial%20productivity%20photography&width=800&height=500&seq=blog-v2-01&orientation=landscape",
    isFeatured: true,
  },
  {
    slug: "best-pandabuy-spreadsheet-sneakers-2026",
    title: "Best Pandabuy Spreadsheet Sneakers of 2026",
    category: "Sneakers",
    description: "Top picks and hidden gems from the sneaker category, with community quality ratings and sizing insights for every recommendation.",
    imageUrl: "https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20of%20multiple%20pairs%20of%20stylish%20sneakers%20in%20various%20neutral%20colors%20arranged%20on%20light%20concrete%20surface%2C%20warm%20natural%20morning%20light%2C%20editorial%20sneaker%20photography%2C%20clean%20minimal%20composition&width=800&height=500&seq=blog-v2-02&orientation=landscape",
  },
  {
    slug: "how-to-use-pandabuy-spreadsheets",
    title: "How to Use Pandabuy Spreadsheets for Maximum Efficiency",
    category: "How-To",
    description: "Master the art of navigating spreadsheet finds with our step-by-step approach to browsing, comparing, and discovering quality items fast.",
    imageUrl: "https://readdy.ai/api/search-image?query=Overhead%20view%20of%20a%20person%20organizing%20digital%20notes%20on%20tablet%20with%20colorful%20sticky%20notes%20and%20fashion%20sketches%20on%20warm%20wooden%20desk%2C%20bright%20natural%20light%2C%20creative%20workspace%20aesthetic&width=800&height=500&seq=blog-v2-03&orientation=landscape",
  },
  {
    slug: "pandabuy-spreadsheet-safety-tips",
    title: "Smart Safety Tips for Spreadsheet Shopping",
    category: "Safety",
    description: "Stay informed and shop confidently with essential safety guidelines for using curated shopping spreadsheets online.",
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20home%20office%20scene%20with%20person%20reviewing%20product%20details%20on%20laptop%20screen%20showing%20checklist%2C%20warm%20natural%20lighting%2C%20calm%20organized%20workspace%2C%20editorial%20photography&width=800&height=500&seq=blog-v2-04&orientation=landscape",
  },
  {
    slug: "pandabuy-spreadsheet-fashion-trends",
    title: "2026 Fashion Trends You Can Find on Pandabuy Spreadsheets",
    category: "Trends",
    description: "Discover the biggest fashion movements of the year — from quiet luxury basics to sport-tech crossovers — all trackable through spreadsheet data.",
    imageUrl: "https://readdy.ai/api/search-image?query=Fashion%20mood%20board%20flat%20lay%20with%20fabric%20swatches%20color%20palette%20samples%20and%20trendy%20clothing%20pieces%20on%20light%20marble%20surface%2C%20warm%20natural%20light%2C%20editorial%20fashion%20design%20aesthetic&width=800&height=500&seq=blog-v2-05&orientation=landscape",
  },
  {
    slug: "pandabuy-spreadsheet-beginner-guide",
    title: "Pandabuy Spreadsheet Beginner Guide: Start Here",
    category: "Beginner",
    description: "Brand new to pandabuyspreadsheet? This friendly walkthrough covers everything from first-time navigation to building your first wishlist.",
    imageUrl: "https://readdy.ai/api/search-image?query=Bright%20airy%20living%20room%20with%20person%20relaxing%20on%20sofa%20browsing%20fashion%20on%20tablet%2C%20warm%20sunlight%20streaming%20through%20window%2C%20cozy%20minimal%20interior%2C%20lifestyle%20photography&width=800&height=500&seq=blog-v2-06&orientation=landscape",
  },
  {
    slug: "pandabuy-spreadsheet-accessories-guide",
    title: "Complete Pandabuy Spreadsheet Accessories Guide",
    category: "Accessories",
    description: "Watches, bags, belts, and sunglasses — how to use the spreadsheet to find the perfect finishing touches for every outfit.",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20of%20various%20fashion%20accessories%20including%20watches%20bracelets%20sunglasses%20and%20belts%20artfully%20arranged%20on%20warm%20beige%20linen%2C%20soft%20natural%20light%2C%20luxury%20editorial%20photography&width=800&height=500&seq=blog-v2-07&orientation=landscape",
  },
  {
    slug: "pandabuy-spreadsheet-quality-comparison",
    title: "How to Spot the Best Quality Items on Pandabuy Spreadsheets",
    category: "Quality",
    description: "Learn to read quality scores, interpret community reviews, and identify high-value items before you click through to purchase.",
    imageUrl: "https://readdy.ai/api/search-image?query=Close%20up%20photography%20of%20hands%20examining%20fabric%20texture%20and%20stitching%20detail%20of%20a%20garment%2C%20warm%20natural%20light%2C%20shallow%20depth%20of%20field%2C%20quality%20inspection%20aesthetic&width=800&height=500&seq=blog-v2-08&orientation=landscape",
  },
  {
    slug: "pandabuy-spreadsheet-daily-updates",
    title: "Why Daily Pandabuy Spreadsheet Updates Give You an Edge",
    category: "Updates",
    description: "How the daily refresh cycle keeps you ahead of trends and ensures you never miss a time-sensitive find or quality drop.",
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20calendar%20and%20digital%20planning%20setup%20on%20warm%20wooden%20desk%20with%20smartphone%20displaying%20shopping%20notifications%2C%20coffee%2C%20morning%20sunlight%2C%20organized%20daily%20routine%20aesthetic&width=800&height=500&seq=blog-v2-09&orientation=landscape",
  },
  {
    slug: "pandabuy-spreadsheet-vs-traditional-shopping",
    title: "Pandabuy Spreadsheet vs Traditional Shopping: Full Comparison",
    category: "Comparison",
    description: "A data-driven look at how spreadsheet shopping stacks up against conventional browsing across time, quality, and satisfaction.",
    imageUrl: "https://readdy.ai/api/search-image?query=Split%20screen%20concept%20showing%20cluttered%20messy%20shopping%20browser%20tabs%20versus%20clean%20organized%20spreadsheet%2C%20warm%20lighting%2C%20editorial%20comparison%20aesthetic%2C%20minimal%20composition&width=800&height=500&seq=blog-v2-10&orientation=landscape",
  },
];

export default function BlogSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12 gap-4">
          <div>
            <p className="text-accent-500 text-sm font-medium tracking-wide uppercase mb-2">
              Latest Content
            </p>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
              Guides &amp; Insights
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-[320px]">
            Original SEO content updated regularly to help you find the best
            deals and navigate spreadsheet shopping like a pro.
          </p>
        </div>

        {/* Featured + 2 columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          {/* Featured - spans 1 col on md+ */}
          {articleCards.slice(0, 1).map((a) => (
            <Link
              key={a.slug}
              to={`/article/${a.slug}`}
              className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-foreground-300 transition-all duration-300 hover:-translate-y-1 cursor-pointer md:col-span-1"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img src={a.imageUrl} alt={a.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
              </div>
              <div className="p-5">
                <span className="inline-block text-xs font-medium text-accent-500 bg-accent-100/70 px-3 py-1 rounded-full mb-3">{a.category}</span>
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-2 leading-snug">{a.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4">{a.description}</p>
                <span className="inline-flex items-center gap-1 text-sm font-medium text-foreground-950 group-hover:text-accent-500 transition-colors">
                  Read Full Guide <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </div>
            </Link>
          ))}

          {/* Two side cards */}
          {articleCards.slice(1, 3).map((a) => (
            <Link
              key={a.slug + "-side"}
              to={`/article/${a.slug}`}
              className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-foreground-300 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img src={a.imageUrl} alt={a.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
              </div>
              <div className="p-5">
                <span className="inline-block text-xs font-medium text-secondary-700 bg-secondary-100/70 px-3 py-1 rounded-full mb-3">{a.category}</span>
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2 leading-snug">{a.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{a.description}</p>
              </div>
            </Link>
          ))}
        </div>

        {/* Remaining 7 articles in a 3-column grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {articleCards.slice(3).map((a, idx) => (
            <Link
              key={a.slug + "-grid-" + idx}
              to={`/article/${a.slug}`}
              className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-foreground-300 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img src={a.imageUrl} alt={a.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
              </div>
              <div className="p-5">
                <span className="inline-block text-xs font-medium text-secondary-700 bg-secondary-100/70 px-3 py-1 rounded-full mb-3">{a.category}</span>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-2 leading-snug">{a.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{a.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}